<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-container
        v-if="!loading && items.length"
        class="py-10 py-md-13 py-lg-16"
      >
        <div
          class="primary--text text-h6 text-md-h5 text-center font-weight-bold"
        >
          Principais Resíduos Coprocessáveis
        </div>

        <div class="justify-center mt-10 grid-list">
          <template v-for="({ title }, keyItems) in items">
            <div
              :key="keyItems"
              class="d-flex align-center px-4 grid-list-item"
            >
              <div
                class="
                  grey--text
                  text--darken-1 text-subtitle-1
                  font-weight-bold
                  item-title
                "
              >
                {{ title }}
              </div>
            </div>
          </template>

          <div
            v-if="text"
            class="
              grey--text
              text--darken-1 text-body-1 text-center
              full-columns
            "
          >
            {{ text }}
          </div>
        </div>
      </v-container>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";

const _config = {
  mod: "coprocessedWaste",
};

export default {
  props: {
    itemsPerPage: {
      type: Number,
      default: 1000,
    },
  },
  data: () => ({
    loading: true,
    text: "Vale ressaltar que a gama de residuos e sua demanda é extensa não prendendo-se apenas ao indicados acima. Faça sua consulta e certifique-se da disponibilidade da coleta específica.",
    items: [],
  }),
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;

      const params = {
        itemsPerPage: this.itemsPerPage,
      };

      this.$rest(_config.mod)
        .get({ params })
        .then((data) => (this.items = data))
        .then(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  components: {
    LoadingWidget,
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  gap: 16px 32px;
  grid-template-columns: repeat(3, minmax(auto, 256px));

  @media screen and (max-width: 960px) {
    grid-template-columns: repeat(2, minmax(auto, 256px));
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: minmax(auto, 450px);
  }

  &-item {
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    height: 54px;

    .item-title {
      line-height: 1.2 !important;
    }
  }

  .full-columns {
    grid-column: 1 / -1;
  }
}
</style>
